module.exports = __webpack_public_path__ + "static/media/Objet_header_blog.acd78527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_bg/Objet_header_blog.png
// module id = 2284
// module chunks = 0